import React from 'react'
import PropTypes from 'prop-types'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons'

const UploadButton = ({ loading = false, size = '' }) => (
  <div>
    {loading ? <LoadingOutlined /> : <PlusOutlined />}
    <div className="ant-upload-text" data-test="uploading_id">
      {size ? `Upload ${size}` : 'Upload'}
    </div>
  </div>
)

UploadButton.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.string
}

export default UploadButton
